import { render, staticRenderFns } from "./PrintDividerYellow.vue?vue&type=template&id=3c322826&"
import script from "./PrintDividerYellow.vue?vue&type=script&lang=js&"
export * from "./PrintDividerYellow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports